export const DashboardOperacaoStatusEnum = {
  Solicitados: 1,
  EmAndamento: 2,
  Atrasados: 0,
  Concluidos: 4,
  Cancelados: 8,
  Rejeitados: 6,
  Todos: 7
}

export const IndexDashboardOperacaoStatusEnumToDescription = (index) => {
  switch (parseInt(index)) {
    case DashboardOperacaoStatusEnum.Todos: return "Todos"
    case DashboardOperacaoStatusEnum.Solicitados: return "Novos Pedidos"
    case DashboardOperacaoStatusEnum.EmAndamento: return "Em Andamento"
    case DashboardOperacaoStatusEnum.Atrasados: return "Atrasados"
    case DashboardOperacaoStatusEnum.Concluidos: return "Concluídos"
    case DashboardOperacaoStatusEnum.Cancelados: return "Cancelados"
    case DashboardOperacaoStatusEnum.Rejeitados: return "Rejeitados"
  }
}
